import client from './client'

export default {
  maintenanceCheck: () => client.get('/api/maintenance-check')
}
